import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import { pathColor } from "@/lib/epidemic";

const dominant = (byPath) => Object.entries(byPath).sort((a, b) => b[1] - a[1])[0]?.[0];

export const EpidemicMap = ({ cities, onSelectCity }) => {
  const points = cities.filter((c) => c.lat != null);
  const max = Math.max(1, ...points.map((p) => p.count));
  return (
    <div className="h-[420px] rounded-lg overflow-hidden border border-stone-200 relative z-0" data-testid="epidemic-map">
      <MapContainer center={[34.5, 3.0]} zoom={5} minZoom={4} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {points.map((p) => {
          const color = pathColor(dominant(p.by_pathology));
          return (
            <CircleMarker key={p.city} center={[p.lat, p.lng]} radius={8 + 22 * Math.sqrt(p.count / max)}
              pathOptions={{ color, fillColor: color, fillOpacity: 0.45, weight: 2 }}
              eventHandlers={{ click: () => onSelectCity?.(p.city) }}>
              <Popup>
                <div className="text-sm" data-testid={`map-popup-${p.city}`}>
                  <p className="font-bold">{p.city} — {p.count} cas</p>
                  {Object.entries(p.by_pathology).sort((a, b) => b[1] - a[1]).map(([k, v]) => <p key={k}>{k} : {v}</p>)}
                </div>
              </Popup>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
};
